import React from "react";
import { NetworkWifi3BarOutlined, SignalWifiOff } from "@mui/icons-material";

/**
 * Get icon for online status widgets
 * @param {object} widget - Full widget object (optional, for accessing current state)
 * @returns {JSX.Element} Icon component
 */
export const getOnlineIcon = (widget = null) => {
  // Determine if device is online
  const isOnline = widget?.items?.$w1?.value === "online";

  const iconProps = {
    style: {
      fontSize: "1.5rem",
      paddingBottom: "2px",
    },
  };

  return isOnline ? (
    <NetworkWifi3BarOutlined {...iconProps} />
  ) : (
    <SignalWifiOff {...iconProps} />
  );
};

export const getOnlineSubtitle = (widget = null) => {
  if (!widget) return "";

  const isOnline = widget?.items?.$w1?.value === "online";

  return isOnline ? "Online" : "Offline";
};

/**
 * Get patterns that this helper supports
 * @returns {string[]} Array of pattern strings
 */
export const getOnlinePatterns = () => {
  return ["basic.device.online"];
};
